import React from 'react';

import {SequencePrime} from 'biojs/BioConstants';
import {RestrictionEnzymeDropdown} from 'molbio/components/RestrictionEnzymeDropdown';
import EnzymeConstants from 'molbio/enzymes/EnzymeConstants';
import {isDoubleCutterEnzyme} from 'molbio/enzymes/EnzymeUtil';
import getTestProps from 'test/lib/cypress/getTestProps';
import FormGroup from 'ui-library/bs/FormGroup';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export default function EndpointRestrictionEnzymeInput({
  className,
  restrictionEnzymeId,
  sequencePrime,
  updateRestrictionEnzymeId,
}: {
  className?: string;
  restrictionEnzymeId: number;
  sequencePrime: SequencePrime;
  updateRestrictionEnzymeId: (id: number) => void;
}): JSX.Element {
  return (
    <div
      className={className}
      {...getTestProps({component: 'EndpointRestrictionEnzymeInput', element: 'root', key: sequencePrime})}
      data-amp-safe={false}
    >
      <FormGroup>
        <FieldLabel
          label={sequencePrime === SequencePrime.FIVE ? "5' enzyme" : "3' enzyme"}
          htmlFor="restrictionEnzyme"
        />
        <RestrictionEnzymeDropdown
          allowedRestrictionEnzymeIds={EnzymeConstants.enzymes
            .filter((enzyme) => !isDoubleCutterEnzyme(enzyme))
            .map((enzyme) => enzyme.id)}
          isDisabled={false}
          restrictionEnzymeId={restrictionEnzymeId}
          updateRestrictionEnzymeId={(restrictionEnzymeId) => {
            updateRestrictionEnzymeId(restrictionEnzymeId);
          }}
          shouldAllowNull={true}
        />
      </FormGroup>
    </div>
  );
}
